import type { ReactElement } from "react";

import type { EmojiCategoryList } from "@platejs/emoji";
import FontAwesome from "../../../../utilities/FontAwesome";

const ActivityIcon = (
  <FontAwesome fixedWidth prefix={"fas"} name={"fa-basketball"} />
);
const CustomIcon = <FontAwesome fixedWidth prefix={"far"} name={"fa-star"} />;
const FlagsIcon = <FontAwesome fixedWidth prefix={"far"} name={"fa-flag"} />;
const FoodsIcon = (
  <FontAwesome fixedWidth prefix={"fas"} name={"fa-apple-whole"} />
);
const FrequentIcon = (
  <FontAwesome fixedWidth prefix={"far"} name={"fa-clock"} />
);
const NatureIcon = <FontAwesome fixedWidth prefix={"fas"} name={"fa-leaf"} />;
const ObjectsIcon = (
  <FontAwesome fixedWidth prefix={"far"} name={"fa-lightbulb"} />
);
const PeopleIcon = <FontAwesome fixedWidth prefix={"far"} name={"fa-smile"} />;
const PlacesIcon = (
  <FontAwesome fixedWidth prefix={"far"} name={"fa-compass"} />
);
const SymbolsIcon = <FontAwesome fixedWidth prefix={"fas"} name={"fa-music"} />;

export const emojiCategoryIcons: Record<
  EmojiCategoryList,
  {
    outline: ReactElement;
    solid: ReactElement; // Needed to add another solid variant - outline will be used for now
  }
> = {
  activity: {
    outline: ActivityIcon,
    solid: ActivityIcon,
  },
  custom: {
    outline: CustomIcon,
    solid: CustomIcon,
  },
  flags: {
    outline: FlagsIcon,
    solid: FlagsIcon,
  },
  foods: {
    outline: FoodsIcon,
    solid: FoodsIcon,
  },
  frequent: {
    outline: FrequentIcon,
    solid: FrequentIcon,
  },
  nature: {
    outline: NatureIcon,
    solid: NatureIcon,
  },
  objects: {
    outline: ObjectsIcon,
    solid: ObjectsIcon,
  },
  people: {
    outline: PeopleIcon,
    solid: PeopleIcon,
  },
  places: {
    outline: PlacesIcon,
    solid: PlacesIcon,
  },
  symbols: {
    outline: SymbolsIcon,
    solid: SymbolsIcon,
  },
};

export const emojiSearchIcons = {
  delete: <FontAwesome fixedWidth prefix={"fas"} name={"fa-xmark"} />,
  loupe: <FontAwesome fixedWidth prefix={"fas"} name={"fa-magnifying-glass"} />,
};
